import { render, staticRenderFns } from "./MeiosDeRecebimento.vue?vue&type=template&id=1a247e4e&"
import script from "./MeiosDeRecebimento.vue?vue&type=script&lang=js&"
export * from "./MeiosDeRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports